import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { FilterKey } from "@studyportals/search-filters";
import { SortingOptions } from "@/sorting/SortingOptions";
import { SearchOrganisationPresenter } from "@/presenters/SearchOrganisationPresenter";
import { FilterOptions } from "@/filters/options/FilterOptions";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class University extends SeoHeadingHandler {

	private readonly organisationPresenter: SearchOrganisationPresenter;

	public constructor(filterOptions: FilterOptions, organisationPresenter: SearchOrganisationPresenter) {
		super(filterOptions);

		this.organisationPresenter = organisationPresenter;
	}

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState)) &&
			(await this.singleSelectionFor(FilterKey.ORGANISATIONS, filterSelectionState))
		);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const idOfOrganisation = this.getFilterOptionValueBy(FilterKey.ORGANISATIONS, filterSelectionState);
		const year = this.getCurrentYearForSeo();

		if (idOfOrganisation === null) {
			return this.createSeoInfoDefault(year);
		}
		return await this.createSeoInfoForOrganisation(idOfOrganisation, year);
	}

	private createSeoInfoDefault(year: number): string {
		return `University Ranking ${year} | Studyportals University Meta Ranking`;
	}

	private async createSeoInfoForOrganisation(idOfOrganisation: string, year: number): Promise<string> {
		const university = await this.organisationPresenter.retrieve(idOfOrganisation);
		if (university === null) {
			return this.createSeoInfoDefault(year);
		}

		return this.createSeoInfo(university.name, year);
	}

	private async createSeoInfo(university: string, year: number): Promise<string> {
		return Promise.resolve(`${university} Ranking ${year} | Studyportals University Meta Ranking`);
	}
}
